/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-12-22 16:26:24
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-12 10:49:46
 * @Content:
 */

import React from "react";
import { IEnterList } from "../../../service/Index";
import config from "../../../utils";
import styles from "../../../styles/index";
import "./index.less";
import { IPostCreateTempDetail } from "../../../service/Index";
import classnames from "classnames";
import { IActivityInfo } from "../../../service/activity/interface";

const PREFIX = "ActivityInfoCard";

interface IProps {
  activityInfo: IActivityInfo;
  tempInfo: IPostCreateTempDetail;
  enter_info: IEnterList;
  onViewProgress: () => void;
  whiteThemeEnable: boolean;
}

export const ActivityInfoCard = (props: IProps): JSX.Element => {
  const {
    activityInfo,
    enter_info,
    onViewProgress,
    tempInfo,
    whiteThemeEnable,
  } = props;

  /**
   * 报名时间、活动时间 label的样式
   */
  const timeLabelStyle = {
    ...styles.coverSignTitle,
    color: whiteThemeEnable ? "rgba(255,255,255,0.8)" : "#222",
  };
  /**
   * 时间 文本的样式
   */
  const timeTextStyle = {
    ...styles.coverSignTime,
    color: whiteThemeEnable ? "#fff" : "#4d4d4d",
  };

  return (
    <div
      style={{
        boxShadow: whiteThemeEnable
          ? "none"
          : "0 1px 20px 0 rgba(199, 215, 221, 0.67)",
        backgroundColor:
          (tempInfo.card_info && tempInfo.card_info.card_color) || "#fff",
      }}
      className={PREFIX}
    >
      <div
        style={{
          ...styles.coverBoxTitle,
          color: whiteThemeEnable ? "#fff" : "#222",
          borderColor: whiteThemeEnable ? "rgba(255,255,255,0.3)" : "#eee",
        }}
      >
        {activityInfo.name}
      </div>
      <div style={styles.coverSignWrapper}>
        <div style={timeLabelStyle}>报名时间</div>
        {activityInfo.special_flag === 1 ? <div style={timeTextStyle}>注册时长14天内的新用户可报名</div> : <div style={timeTextStyle}>
          {config.formatDate(activityInfo.enter_start)} -{" "}
          {config.formatDate(activityInfo.enter_end)}
        </div>}

      </div>
      <div>
        <div style={timeLabelStyle}>活动时间</div>
        <div style={timeTextStyle}>
          {config.formatDate(activityInfo.effect_start)} -{" "}
          {config.formatDate(activityInfo.effect_end)}
        </div>
      </div>

      <div
        className={`${PREFIX}-join`}
        style={{
          ...styles.coverJoinWrapper,
          display: enter_info.enter_count > 0 ? "flex" : "none",
        }}
      >
        <div style={styles.coverPortraitWrapper}>
          {enter_info.avatar_list &&
            enter_info.avatar_list.map((item, index) => {
              return (
                <img src={item} style={styles.coverPortrait} key={index} />
              );
            })}
        </div>
        <div
          style={{
            ...styles.coverJoinNum,
            color: whiteThemeEnable ? "#fff" : "#4d4d4d",
          }}
        >
          {enter_info.enter_count}人参与
        </div>
      </div>
      {/* 报名后才能从活动详情页进入进行中页面 */}
      {activityInfo.enter_status ? (
        <div className={`${PREFIX}-footer`}>
          <div
            onClick={onViewProgress}
            className={classnames(`${PREFIX}-footerBtn`, {
              ["is-white"]: whiteThemeEnable,
            })}
          >
            <div className={`${PREFIX}-footerBtnText`}>查看完成进度</div>
            <img
              className={`${PREFIX}-footerBtnIcon`}
              src={
                whiteThemeEnable
                  ? "https://s1.codooncdn.com/operation-tools/internal-user/2020-12-23T17.06.03/9x14x262xWOlNAnakN5h2wx0J9e.png"
                  : "https://s1.codooncdn.com/operation-tools/internal-user/2020-10-30T10.13.39/9x14x332xpauHMgIoDs2zmyDxvK.png"
              }
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};
